document.addEventListener('DOMContentLoaded', function () {

  /* =========================================================
     COLLECTION SORT
     ========================================================= */

  const selectElement =
    document.querySelector('#js-nice-select');

  if (
    selectElement &&
    typeof NiceSelect !== 'undefined'
  ) {

    NiceSelect.bind(
      selectElement,
      {
        searchable: false
      }
    );

    selectElement.addEventListener(
      'change',
      function () {

        const form =
          this.closest('form');

        if (form) {
          form.submit();
        }

      }
    );
  }

});


// document.addEventListener('DOMContentLoaded', function () {

//   document.querySelectorAll('#FacetFiltersForm input').forEach(function (el) {
//       el.addEventListener('change', function () {
//           document.getElementById('FacetFiltersForm').submit();
//       });
//   });

//   document.querySelectorAll('#FacetFiltersForm input[type="number"]').forEach(function (el) {
//       el.addEventListener('keydown', function (e) {
//           if (e.key === 'Enter') document.getElementById('FacetFiltersForm').submit();
//       });
//   });

//   const selectElement = document.querySelector('#js-nice-select');
//   if (selectElement) {
//       NiceSelect.bind(selectElement, { searchable: false });

//       selectElement.addEventListener('change', function () {
//       this.closest('form').submit();
//       });
//   }

//   document.querySelectorAll('.filter-group summary').forEach(function (summary) {
//       summary.addEventListener('click', function (e) {
//           e.preventDefault();
//           var details = summary.closest('details');
//           if (details.hasAttribute('open')) {
//           details.removeAttribute('open');
//           } else {
//           details.setAttribute('open', '');
//           }
//       });
//   });

//   (function () {
//     const LIMIT = 6;

//     document.querySelectorAll('.filter-group__body-inner').forEach(function (body) {
//       const items = Array.from(body.querySelectorAll(
//         ':scope > label, :scope > .filter-swatches > label, :scope > .filter-sizes > label, :scope > .filter-categories > li'
//       ));

//       const container = body.querySelector('.filter-swatches, .filter-sizes, .filter-categories') || body;
//       const allItems = Array.from(container.querySelectorAll(':scope > label, :scope > li'));

//       if (allItems.length <= LIMIT) return;

//       allItems.forEach(function (item, i) {
//         if (i >= LIMIT) {
//           item.style.display = 'none';
//           item.dataset.filterHidden = 'true';
//         }
//       });

//       const btn = document.createElement('button');
//       btn.type = 'button';
//       btn.className = 'filter-show-more';
//       btn.textContent = 'Show more (' + (allItems.length - LIMIT) + ')';

//       let expanded = false;
//       btn.addEventListener('click', function () {
//         expanded = !expanded;
//         allItems.forEach(function (item, i) {
//           if (i >= LIMIT) {
//             item.style.display = expanded ? '' : 'none';
//           }
//         });
//         btn.textContent = expanded
//           ? 'Show less'
//           : 'Show more (' + (allItems.length - LIMIT) + ')';
//       });

//       container.after(btn);
//     });
//   })();

//   (function () {
//     const minRange = document.getElementById('price-range-min');
//     const maxRange = document.getElementById('price-range-max');
//     const minInput = document.getElementById('Filter_Price_GTE');
//     const maxInput = document.getElementById('Filter_Price_LTE');
//     const fill    = document.getElementById('price-range-fill');

//     if (!minRange || !maxRange) return;

//     const rangeMax = parseFloat(minRange.max);

//     function updateFill() {
//       const minVal = parseFloat(minRange.value);
//       const maxVal = parseFloat(maxRange.value);
//       const left   = (minVal / rangeMax) * 100;
//       const right  = 100 - (maxVal / rangeMax) * 100;
//       fill.style.left  = left + '%';
//       fill.style.right = right + '%';
//     }

//     function clampValues() {
//       const minVal = parseFloat(minRange.value);
//       const maxVal = parseFloat(maxRange.value);
//       if (minVal >= maxVal) {
//         minRange.value = maxVal - 1;
//       }
//     }

//     minRange.addEventListener('input', function () {
//       clampValues();
//       minInput.value = minRange.value;
//       updateFill();
//     });

//     maxRange.addEventListener('input', function () {
//       clampValues();
//       maxInput.value = maxRange.value;
//       updateFill();
//     });

//     [minRange, maxRange].forEach(function (el) {
//       el.addEventListener('change', function () {
//         document.getElementById('FacetFiltersForm').submit();
//       });
//     });

//     minInput.addEventListener('input', function () {
//       let val = parseFloat(this.value) || 0;
//       val = Math.min(val, parseFloat(maxRange.value) - 1);
//       minRange.value = val;
//       updateFill();
//     });

//     maxInput.addEventListener('input', function () {
//       let val = parseFloat(this.value) || rangeMax;
//       val = Math.max(val, parseFloat(minRange.value) + 1);
//       maxRange.value = val;
//       updateFill();
//     });

//     if (!maxInput.value || maxInput.value === '0') {
//       maxInput.value = rangeMax;
//       maxRange.value = rangeMax;
//     }
//     updateFill();
//   })();
// });